import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { contactInfo } from '../mockData';
import { trackButtonClick } from '../utils/analytics';

const Footer = () => {
  const handleLinkClick = (linkName) => {
    trackButtonClick(`footer_${linkName}`, 'footer');
  };

  return (
    <footer className="bg-[#0A1F44] text-white">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="https://tally-bharat.s3.ap-south-1.amazonaws.com/tb-logo.png"
              alt="TallyBharat Logo"
              className="h-12 w-auto brightness-0 invert"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Empowering Bharat's businesses with secure, fast, and reliable Tally cloud hosting since 2004.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2.5">
              {['Home', 'Services', 'Pricing', 'About Us', 'Contact Us', 'Careers'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-')}`}
                    onClick={() => handleLinkClick(item.toLowerCase().replace(' ', '_'))}
                    className="text-gray-300 hover:text-[#FF7A00] transition-colors duration-200 text-sm inline-block"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2.5">
              {[
                { name: 'Tally Cloud Hosting', link: '/services' },
                { name: 'Multi-User Access', link: '/services' },
                { name: 'Auto Backups', link: '/services' },
                { name: 'Partner Program', link: '/partner-program' },
                { name: 'Server Support', link: '/services' }
              ].map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.link}
                    onClick={() => handleLinkClick('service_' + item.name.toLowerCase().replace(' ', '_'))}
                    className="text-gray-300 hover:text-[#FF7A00] transition-colors duration-200 text-sm inline-block"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-[#FF7A00] flex-shrink-0 mt-0.5" />
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-300 hover:text-[#FF7A00] transition-colors text-sm"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-[#FF7A00] flex-shrink-0 mt-0.5" />
                <div className="space-y-1">
                  <a
                    href={`tel:${contactInfo.phone1}`}
                    className="text-gray-300 hover:text-[#FF7A00] transition-colors text-sm block"
                  >
                    {contactInfo.phone1}
                  </a>
                  <a
                    href={`tel:${contactInfo.phone2}`}
                    className="text-gray-300 hover:text-[#FF7A00] transition-colors text-sm block"
                  >
                    {contactInfo.phone2}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#FF7A00] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">{contactInfo.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Clock size={18} className="text-[#FF7A00] flex-shrink-0 mt-0.5" />
                <div className="text-gray-300 text-sm space-y-1">
                  <div><span className="font-semibold">Sales:</span> Mon-Sat 10AM - 7PM</div>
                  <div><span className="font-semibold">Support:</span> 24/7 (Chat, Phone, Email)</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} TallyBharat. All rights reserved. | Authorized Tally Partner since 2004
            </p>
            <div className="flex items-center space-x-6">
              <Link
                to="/privacy-policy"
                onClick={() => handleLinkClick('privacy_policy')}
                className="text-gray-400 hover:text-[#FF7A00] transition-colors text-sm"
              >
                Privacy Policy
              </Link>
              <Link
                to="/return-policy"
                onClick={() => handleLinkClick('return_policy')}
                className="text-gray-400 hover:text-[#FF7A00] transition-colors text-sm"
              >
                Return Policy
              </Link>
            </div>
          </div>
          {/* AIO INFINITY Credit */}
          <div className="text-center mt-8">
            <p className="text-gray-300 text-base mb-3">
              Site Designed & Deployed by{' '}
              <a
                href="https://www.aioinfinity.in"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => handleLinkClick('aio_infinity_main')}
                className="text-[#FF7A00] hover:text-[#e66d00] transition-colors duration-200 font-semibold"
              >
                AIO INFINITY PRIVATE LIMITED
              </a>
              {' '}✨
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;